import { Divider } from './types';

const dividerTheme: Divider = {
	colors: {
		background: '',
		modes: {
			light: { background: 'neutral.100' },
			dark: { background: '#FFFFFF1A' }
		}
	}
};

export default dividerTheme;
